import clsx from 'clsx';
import React from 'react';

export default function LoaderLinear({ show, className }) {
    return <div className={clsx('linear-loader', className, { 'linear-loader-hide': !show })} />;
}
